<!-- 选手设置 -->
<template>
<div>  
    <el-form :model="searchForm" ref="searchForm"  label-width="100px" :inline="true"> 
        <el-form-item label="选手姓名" prop="status">
            <el-input v-model="searchForm.username" 
                maxlength="10"
                placeholder="请输入选手姓名">                  
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="searchQuery('searchForm')" >查询</el-button>
            <el-button @click="resetForm('searchForm')" >重置</el-button>  
            <el-button type="primary"  @click="toggleAssociationColumn">
                {{ showAssociationColumn ? '隐藏协会列' : '显示协会列' }}
            </el-button>
            <el-button  @click="handleDownLoadXLS" type="success">下载导入模板</el-button>   
            <span class="red size20">注意：导入数据时单人赛搭档姓名为空</span> 
        </el-form-item>          
    </el-form>  
    <div class="flex-row-1"> 
        <div class="player-table custom-table2">
            <el-table :data="firstTableData"  border v-if="firstTableData.length > 0">
            <el-table-column
                width="50"
                prop="id"
                label="编号"        
                align="center"
                >
            </el-table-column>
            <el-table-column
                prop="company"
                label="协会(俱乐部)"
                align="center"   
                v-if="showAssociationColumn"             
            >
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.companyId === 0 ? 'inline-input' : ''"
                    v-model="scope.row.company"
                    :fetch-suggestions="querySearchCompany"
                    placeholder=""
                    :trigger-on-focus="false"                    
                    @select="handleSelectCompany"
                    @change="handleChangeCompany(scope.row)"
                    @blur="handleBlur(scope.row,'c')"
                ></el-autocomplete>
            </template>       
            </el-table-column>
            <el-table-column
            prop="username"
            label="选手姓名"
            align="center">
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.phone ===''? 'inline-input': ''"
                    v-model="scope.row.username"
                    :fetch-suggestions="querySearchRealname"
                    placeholder=""
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'a')"
                    @select="handleSelectRealname"                    
                    @change="handleChangeRealname(scope.row)"
                    @input="handleInputUsername"                   
                >
            </el-autocomplete>
            </template>
            </el-table-column>
            <el-table-column v-if="pubType === '2'"
                prop="partnername"
                label="搭档姓名"
                align="center"            
                >
            <template slot-scope="scope" >
                <el-autocomplete
                    :class="scope.row.partnerPhone ===''? 'inline-input': ''"
                    v-model="scope.row.partnername"
                    :fetch-suggestions="querySearchPartnerName"
                    placeholder=""
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'b')"
                    @select="handleSelectPartnerName"
                    @change="handleChangePartnerName(scope.row)"
                    @input="handleInputPatername"
                >
                </el-autocomplete>
            </template>
            </el-table-column>
            <el-table-column
            prop="number"
            :label="maxNumberFirst"
            align="center">
            <template slot-scope="scope">
            <el-tooltip   effect="dark"  :content="scope.row.phone?scope.row.phone:'无'" placement="top">
                <el-button :class="scope.row.status === '参赛'? 'green':'red'" @click="handleSwitch(scope.row)" type="text" size="medium">{{ scope.row.status ==='参赛'?'已签到':'未签到'}}</el-button>
            </el-tooltip>
                <el-button @click="handleDelete(scope.row)" type="text" size="medium" v-if="round ===1">删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        </div>       
        <div class="player-table custom-table2" style="margin-left:5px">
            <el-table :data="secondTableData"  border             
            v-if="secondTableData.length > 0">
            <el-table-column
            width="50"
            prop="id"
            label="编号"        
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="company"
            label="协会(俱乐部)"
            align="center"
            v-if="showAssociationColumn"  
            >
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.companyId === 0 ? 'inline-input' : ''"
                    v-model="scope.row.company"
                    :fetch-suggestions="querySearchCompany"
                    placeholder=""
                    :trigger-on-focus="false"
                    @select="handleSelectCompany"
                    @change="handleChangeCompany(scope.row)"
                    @blur="handleBlur(scope.row,'c')"
                ></el-autocomplete>
            </template>       
            </el-table-column>
            <el-table-column
            prop="username"
            label="选手姓名"
            align="center">
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.phone ===''? 'inline-input': ''"
                    v-model="scope.row.username"
                    :fetch-suggestions="querySearchRealname"
                    placeholder=""
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'a')"
                    @select="handleSelectRealname"
                    @change="handleChangeRealname(scope.row)"
                    @input="handleInputUsername"
                ></el-autocomplete>
            </template>
            </el-table-column>
            <el-table-column v-if="pubType === '2'"
            prop="partnername"
            label="搭档姓名"
            align="center">
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.partnerPhone ===''? 'inline-input': ''"
                    v-model="scope.row.partnername"
                    :fetch-suggestions="querySearchPartnerName"
                    placeholder=""
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'b')"
                    @select="handleSelectPartnerName"
                    @change="handleChangePartnerName(scope.row)"
                    @input="handleInputPatername"
                ></el-autocomplete>        
            </template>
            </el-table-column>
            <el-table-column
                prop="number"
                :label="maxNumberSecond"
                align="center">
                <template slot-scope="scope">
                <el-tooltip  effect="dark"  :content="scope.row.phone?scope.row.phone:'无'" placement="top">
                    <el-button :class="scope.row.status === '参赛'? 'green':'red'" @click="handleSwitch(scope.row)" type="text" size="medium">{{ scope.row.status ==='参赛'?'已签到':'未签到'}}</el-button>
                </el-tooltip>
                    <el-button @click="handleDelete(scope.row)" type="text" size="medium" v-if="round ===1">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <div class="player-table custom-table2" style="margin-left:5px">
            <el-table :data="thirdTableData"  border             
            v-if="thirdTableData.length > 0">
            <el-table-column
            width="50"
            prop="id"
            label="编号"        
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="company"
            label="协会(俱乐部)"
            align="center"
            v-if="showAssociationColumn"  
            >
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.companyId === 0 ? 'inline-input' : ''"
                    v-model="scope.row.company"
                    :fetch-suggestions="querySearchCompany"                    
                    :trigger-on-focus="false"
                    @select="handleSelectCompany"
                    @change="handleChangeCompany(scope.row)"
                    @blur="handleBlur(scope.row,'c')"
                ></el-autocomplete>
            </template>       
            </el-table-column>
            <el-table-column
            prop="username"
            label="选手姓名"
            align="center">
            <template slot-scope="scope" >
                <el-autocomplete
                    :class="scope.row.phone ===''? 'inline-input': ''"
                    v-model="scope.row.username"
                    :fetch-suggestions="querySearchRealname"                    
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'a')"
                    @select="handleSelectRealname"
                    @change="handleChangeRealname(scope.row)"
                    @input="handleInputUsername"
                ></el-autocomplete>
            </template>
            </el-table-column>
            <el-table-column v-if="pubType === '2'"
            prop="partnername"
            label="搭档姓名"
            align="center">
            <template slot-scope="scope" >
                <el-autocomplete 
                    :class="scope.row.partnerPhone ===''? 'inline-input': ''"
                    v-model="scope.row.partnername"
                    :fetch-suggestions="querySearchPartnerName"                
                    :trigger-on-focus="false"
                    @blur="handleBlur(scope.row,'b')"
                    @select="handleSelectPartnerName"
                    @change="handleChangePartnerName(scope.row)"
                    @input="handleInputPatername"
                ></el-autocomplete>
            </template>
            </el-table-column>
            <el-table-column
                prop="number"
                :label="maxNumberThird"
                align="center">
                <template slot-scope="scope">
                <el-tooltip  effect="dark"  :content="scope.row.phone?scope.row.phone:'无'" placement="top">
                    <el-button :class="scope.row.status === '参赛'? 'green':'red'" @click="handleSwitch(scope.row)" type="text" size="medium">{{ scope.row.status ==='参赛'?'已签到':'未签到'}}</el-button>
                </el-tooltip>
                    <el-button @click="handleDelete(scope.row)" type="text" size="medium" v-if="round ===1">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
    </div>
    <el-row class="my-button-container mg-t-20">
        <el-button  @click="handleAdd" type="primary" size="medium">添加选手</el-button>  
        <el-button  @click="handleDesk" type="danger" size="medium">加一桌</el-button>  
        <el-button  @click="handleSetId(1)" type="success" size="medium">顺序编号</el-button>  
        <el-button  @click="handleSetId(2)" type="warning" size="medium">随机编号</el-button> 
        <el-button  @click="handleSignAllAPI" type="primary" size="medium">全部签到</el-button> 
        <el-button  @click="handleRemoveAll" type="danger" size="medium">全部删除</el-button> 
        <el-button  @click="handleExport" type="success" size="medium">导出</el-button>   
        <span class="file-excel">
            <label for="fileInput" class="input-button" >导入</label> 
            <input type="file" class="input-file" @change="handleImport" ref="fileInput" accept=".xlsx, .xls" />
        </span> 
    </el-row>       
    <el-row class="red size20">添加或删除选手请重新编号</el-row>
    <!-- 使用组件上传文件 -->
    <!-- <div>       
        <el-upload
        class="upload-demo"
        action=""
        name="file"
        :on-change="handleFileUpload"
        :before-upload="beforeUpload"
        :on-remove="handleRemove"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        accept=".xlsx, .xls"
        >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
    </el-upload>
        <div v-if="importData.length">
        <h3>导入的数据:</h3>
        <table>
            <thead>
            <tr>
                <th v-for="(header, index) in importData[0]" :key="index">{{ header }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, rowIndex) in importData.slice(1)" :key="rowIndex">
                <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
            </tr>
            </tbody>
        </table>
        </div>
    </div> -->
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
    props:{
        pubId: {
            type: String,
            default: ''
        },
        pubType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            searchForm: {
                username: ''
            },
            tableData: [],
            firstTableData: [],
            secondTableData: [],
            thirdTableData: [],
            maxNumber: '',
            maxNumberFirst: '',
            maxNumberSecond: '',
            maxNumberThird: '',
            round: '',
            noSignData: [],
            userInfoOption: [],
            realNameOption: [],
            partnerNameOption: [],
            companyOption: [],
            exportData: [],
            timer: null,
            second: 30,
            loading: false,
            selectStatus: false,
            importData: [],   
            fileList: [],   
            showAssociationColumn: true,
        }
    
    },
    created() {
    },
    mounted() {

    },
    computed:{

    },
    beforeDestroy() {
        this.stopCountdown()  
    },
    methods: {
        ...mapMutations(['SET_ROUND']),
         // 获取赛事报名选手查询
         getPlayer(){
            let params = {
                opcode: this.$code.PlayerCode,
                i_serial_mark: this.pubId,
                v_player_no: '',
                v_player_name: '',
                v_player_phone: '',
                v_player_association: '',
                v_player_association_no: '',
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable

                    this.tableData = result.map(item=>{   
                    let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']                   
                        return{
                            id: item['选手编号'],
                            username: username,
                            phone: item['选手手机号'],
                            publishId: item['赛事标识'],
                            company: item['协会（俱乐部）'],
                            status: item['状态'],
                            userId: item['选手账号'],
                        }
                    })
                    
                    let unit = this.pubType === '2'?'对': '人'      
                    this.maxNumber = result.length + unit
                    // console.log('赛事选手报名的接口',this.maxNumber)     
                }
            })
        },
        // 对阵赛事选手
        initData(){
            let params = {
                opcode: this.$code.PubEncounter,
                i_serial_mark: this.pubId,
                name: this.searchForm.username,
                i_players_number: '',
             }
             this.loading = true
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    this.loading = false
                    let result = res.Data.DataTable
                    if(result.length > 0){                   
                        this.tableData  = result.map(item=>{
                            return{                            
                                id: item['选手编号'],
                                username: item['选手名称'],
                                partnername: item['搭档名称'],
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                publishId: item['赛事标识'],
                                userId: item['选手账号'],
                                parterId: item['搭档账号'],
                                round: item['比赛轮数']+1,
                                maxRound: item['赛事轮数'], 
                                status: item['状态'],
                                partnerPhone: item['搭档手机号'],
                                companyId: item['协会（俱乐部）账号']
                            }
                        })
                        if(this.pubType === '1'){
                            this.exportData = result.map(item=>{
                                return{                            
                                    '选手编号': item['选手编号'],
                                    '选手名称': item['选手名称'],
                                    '选手手机号': item['选手手机号'],   
                                    '协会（俱乐部）': item['协会（俱乐部）'],
                                    '签到状态': item['状态'] ==='参赛'?'已签到':'未签到'
                                }
                            })
                        }else{
                            this.exportData = result.map(item=>{
                                return{                            
                                    '选手编号': item['选手编号'],
                                    '选手名称': item['选手名称'],
                                    '搭档名称': item['搭档名称'],
                                    '选手手机号': item['选手手机号'],   
                                    '搭档手机号': item['搭档手机号'],
                                    '协会（俱乐部）': item['协会（俱乐部）'],
                                    '签到状态': item['状态'] ==='参赛'?'已签到':'未签到'
                                }
                            })
                        }                       
                        let  playerArr  = JSON.parse(JSON.stringify(this.tableData))
                        if(playerArr.length > 20){                          
                            if(playerArr.length > 30){
                                const chunkSize =  Math.ceil(playerArr.length / 3)
                                const chunkedArrays = this.splitArrayIntoChunks(playerArr, chunkSize);
                                this.firstTableData = chunkedArrays[0]
                                this.secondTableData = chunkedArrays[1]
                                this.thirdTableData = chunkedArrays[2]
                                // console.log(chunkedArrays)
                            }else{
                                const splitSize = Math.round(playerArr.length / 2); 
                                this.firstTableData = playerArr.slice(0, splitSize);  
                                this.secondTableData = playerArr.slice(splitSize);  
                                this.thirdTableData = []
                            }
                        }else{
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }
                        let unit = this.pubType === '2'?'对': '人'
                        this.maxNumber = playerArr.length
                        this.maxNumberFirst = this.firstTableData.length + unit 
                        this.maxNumberSecond = this.secondTableData.length + unit 
                        this.maxNumberThird = this.thirdTableData.length + unit 
                        this.round = this.tableData[0].round <= this.tableData[0].maxRound ? this.tableData[0].round : this.tableData[0].maxRound
                        // console.log('赛事222',this.maxNumber)   
                        this.SET_ROUND(this.round) 

                    }else{
                        this.$message.error('请先添加比赛选手！')
                        this.tableData = []
                        this.firstTableData = []
                        this.secondTableData = []
                        this.thirdTableData = []
                        this.stopCountdown()
                    }
                 }
             }).catch(err=>{
                this.stopCountdown()
             })
        },
        // 创建一个函数来均分数组
        splitArrayIntoChunks(array, chunkSize){
            const chunks = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                chunks.push(array.slice(i, i + chunkSize));
            }
            return chunks;
        },
        handleAdd(){
            this.addOnePlayer() 
        },       
        addOnePlayer(key){          
            let n =  Math.floor(Math.random() * 1000)
            let params = {
                opcode: this.$code.ApplyCode,
                i_serial_mark: this.pubId,
                v_player_no: '', 
                v_player_name: '空' + n,
                v_player_phone: '',
                v_partner_no: '',
                v_partner_name: this.pubType === '2' ? '空' + n : '',
                v_partner_phone: '',
                v_player_association: '',
                v_player_association_no: ''                 
            };
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    this.initData()
                } else {
                    this.$message.error(res.Message)
                }
            })      
        },
        handleDesk(){
             // 单人赛新增2条  双人赛新增4条
            if(this.pubType === '2'){  
                this.callApisSequentially([0,1]).then(()=>{
                    // console.log('All APIs called sequentially')
                    this.initData()
               })
            }else{
               this.callApisSequentially([0,1,2,3]).then(()=>{
                    // console.log('All APIs called sequentially')
                    this.initData()
               })
            }
        },
        addPlayer(){
            return new Promise((resolve, reject) => {
                let n =  Math.floor(Math.random() * 1000)
                let params = {
                    opcode: this.$code.ApplyCode,
                    i_serial_mark: this.pubId,
                    v_player_no: '', 
                    v_player_name: '空' + n,
                    v_player_phone: '',
                    v_partner_no: '',
                    v_partner_name: this.pubType === '2' ? '空' + n : '',
                    v_partner_phone: '',
                    v_player_association: '',
                    v_player_association_no: ''                 
                };
                this.$api.requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        if(res.IsSuccess){
                            resolve(res)
                        }                        
                    } else {
                        this.$message.error(res.Message)
                    }
                }).catch(err=>{
                    reject(err)
                })      
            })
        },
        // 加一桌异步循环调用接口
        async callApisSequentially(urls) { 
            return urls.reduce(async (promiseChain, url) =>{
                await  promiseChain
                try {  
                    const res = await this.addPlayer(url); 
                    // console.log(res)  
                } catch (error) {  
                    console.error(`Error calling API at ${url}`, error);  
                }  
            }, Promise.resolve()) 
        },
        handleSwitch(row){            
            let f = row.status === '弃权'? '参赛': '弃权'
            let flag = row.status === '弃权'? 1 : 2
            this.$confirm(`确认${f}吗？`)
            .then(_ => {
                this.submit(row,flag);
            })
            .catch(_ => {});
        },
        // 确认签到或弃权
        submit(row,flag){
            // console.log(row,flag)
            let params = {
                opcode: this.$code.PubWaive,
                i_serial_mark: row.publishId,
                v_player_no: row.userId,
                v_player_name: row.username,
                v_player_phone: row.phone,
                v_partner_no: row.parterId,
                v_partner_name: row.partnername,
                v_partner_phone: row.partnerPhone,
                c_status: flag,
            }
            this.$api.requestAPI(params).then(res=>{
                if (res.IsSuccess) {
                    this.initData()
                } else {
                    this.$message.error(res.Message)
                }
            })
        },
        handleDelete(row){
            let params = {
                opcode: this.$code.PubRemove,
                i_serial_mark: row.publishId,
                i_players_number: row.id
            }
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    if(this.tableData.length > 1){
                        this.handleSetId(1)
                    }else{
                        this.initData()
                    }                    
                } else {
                    this.$message.error(res.Message)
                }
            })
        },
        handleSetId(value){
            let params = {
                opcode: this.$code.SetPlayerId,
                i_serial_mark: this.pubId,
                i_flag: value
            }
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    this.initData()
                } else {
                    this.$message.error(res.Message)
                }
            })
        },
        // 全部签到 查询出未签到的数据  循环签到
        handleSignAll(row){
            return new Promise((resolve, reject) => { 
                let params = {
                opcode: this.$code.PubWaive,
                i_serial_mark: row.publishId,
                v_player_no: row.userId,
                v_player_name: row.username,
                v_player_phone: row.phone,
                v_partner_no: row.parterId,
                v_partner_name: row.partnername,
                v_partner_phone: row.partnerPhone,
                c_status: 1,
                }
                this.$api.requestAPI(params).then(res=>{
                    if (res.IsSuccess) {
                        resolve(res)                 
                    }
                }).catch(err=>reject(err))
            })
        },
         // 异步调用函数 
         async callApisSignAll(arr) {  
            return arr.reduce(async (promiseChain, data) =>{
                await  promiseChain
                try {  
                    const res = await this.handleSignAll(data); 

                } catch (error) {  
                    // console.error(`Error calling API at`, error);  
                }  
            }, Promise.resolve()) 
        }, 
        handleSignAllAPI(){
            let newArr = JSON.parse(JSON.stringify(this.tableData)) 
            this.noSignData = newArr.filter(i=>i.status === '弃权')
            // console.log(newArr,this.noSignData)
            if(this.noSignData.length > 0){
                this.callApisSignAll(this.noSignData).then(res=>{
                    this.initData()
                    // console.log("调用完了")
                })
            }else{
                this.$message.error('暂无未签到的选手！')
            }           
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.userInfoOption = []
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value: item['姓名'] +''+ item['手机号'],
                                        label: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],
                                        role: item['角色'],
                                        level: item['星级']
                                }
                            })                            
                            this.userInfoOption = arr.filter(i=>i.role === '选手'||i.role === '掼蛋协会'||i.role === '掼蛋俱乐部')
                            // console.log(this.userInfoOption)
                            resolve(this.userInfoOption)                         
                        }
                    }
                    }).catch(err => { reject(err)})
                }
            })         
        },
        async querySearchPartnerName(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        handleChangePartnerName(row){
            // console.log("搭档信息",row)
            // console.log('选择的会员信息',this.userInfoOption)
            this.partnerNameOption = {...row}
            this.selectStatus = true        
        },
        handleSelectPartnerName(item){   
            if(item.phone !== ''){
                this.partnerNameOption.parterId = item.label
                this.partnerNameOption.partnername = item.username 
                this.partnerNameOption.partnerPhone = item.phone               
                setTimeout(()=>{
                    this.updatePlayer(this.partnerNameOption)
                },100)
            }
        },
        async querySearchRealname(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },        
        handleChangeRealname(row){
            // console.log(row)
            this.realNameOption = {...row}
            this.selectStatus = true          
        },
        handleSelectRealname(item){ 
            // console.log('选择选手',item,)   
            if(item.phone !== ''){
                this.realNameOption.userId = item.label
                this.realNameOption.username = item.username
                this.realNameOption.phone = item.phone
                setTimeout(()=>{
                    this.updatePlayer(this.realNameOption)
                },100)
            }
        },
        async querySearchCompany(queryString,cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        handleChangeCompany(row){
            this.companyOption = {...row}
            // if(this.userInfoOption.length === 0){
            //     this.updatePlayer(this.companyOption)
            // }    
            this.selectStatus = true          
        },
        handleSelectCompany(item){
            if(item.label !== ''){
                this.companyOption.companyId = item.label
                this.companyOption.company = item.username
                setTimeout(()=>{
                    this.updatePlayer(this.companyOption)
                },100)
            }else{
                // this.updatePlayer(this.companyOption)
            } 
        },
        updatePlayer(row){
            let params = {
                opcode: this.$code.PubUpdateName,
                i_serial_mark: row.publishId,
                i_players_number: row.id,
                v_player_no: row.userId, 
                v_player_name:  row.username.trim(),
                v_player_phone: row.phone,
                v_partner_no: row.parterId,
                v_partner_name: row.partnername && row.partnername.trim(),
                v_partner_phone: row.partnerPhone,
                v_player_association: row.company && row.company.trim(),
                v_player_association_no: row.companyId, 
            }
            // console.log('修改用户信息的参赛',params)
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    this.initData()
                    this.selectStatus = false
                } else {
                    this.$message.error(res.Message)
                }
            })
        },
        handleInputUsername(value){
            // console.log(value)
            this.userInfoOption = []
        },
        handleInputPatername(value){
            // console.log(value)
            this.userInfoOption = []
        },
        handleBlur(row,type){
            // console.log(this.userInfoOption)
            console.log("失去焦点",row,this.selectStatus,this.userInfoOption.length )    
            this.partnerNameOption = {...row}
            this.realNameOption = {...row}
            this.companyOption = {...row}
            if(this.selectStatus){  
                console.log("不选择会员调用1")
                if(type === 'a'){
                // console.log('a')
                    row.userId = 0
                    row.phone = ''
                    setTimeout(()=>{
                        this.updatePlayer(row)
                    },100)
                }else if(type === 'b'){
                    // console.log('b')
                    row.parterId = 0
                    row.partnerPhone = ''
                    setTimeout(()=>{
                        this.updatePlayer(row)
                    },100)
                }else if(type === 'c'){
                    console.log('c')
                    row.companyId = 0
                    setTimeout(()=>{
                        this.updatePlayer(row)
                    },100)
                } 
            }          
        },
        // 导出表格
        handleExport(){
            // // 假设有一个表格数据的数组
            // // console.log(this.exportData)
            // // aoa_to_sheet array
            // // const data = [
            // //     ["选手编号","选手姓名", "搭档姓名", "选手手机号","搭档手机号","协会（俱乐部）"],
            // //     []
            // // ];
        
            // // 将数据转换为工作表
            // const worksheet = XLSX.utils.json_to_sheet(this.exportData);
        
            // // 创建工作簿并添加工作表
            // const workbook = XLSX.utils.book_new();
            // XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
            // // 生成Excel文件
            // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        
            // // 使用blob和FileReader创建一个Blob URL   type: application/octet-stream
            // const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            // const blobUrl = window.URL.createObjectURL(dataBlob);
        
            // // 使用saveAs下载文件
            // saveAs(dataBlob, '选手信息.xlsx');
        
            // // 清理
            // window.URL.revokeObjectURL(blobUrl);
            this.$help.ExportFormData(this.exportData, '选手信息')
        },
        stopCountdown(){
            clearInterval(this.timer)
            this.timer = null
        },
        countDown(){            
            this.timer = setInterval(()=>{
                if(this.second > 0 ){
                    this.second--
                }else{
                    this.second = 30
                    this.initData()
                }
            },1000)
        },
        searchQuery(){
            if(this.searchForm.username.length >1){
                this.initData()
            }else{
                this.$message.error('请输入正确的选手姓名！')
            }
            
        },
        resetForm(){
            this.searchForm.username = ''
            this.initData()
        },    
        handleImport(event){
            console.log(event)
            const file = event.target.files[0];
            if (!file) return;
        
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
        
                // 假设我们只处理第一个工作表
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // header: 1 表示第一行是标题行
        
                // this.importData = jsonData;
                // console.log(this.importData.slice(1))
                
                const excelDataFormat = jsonData.slice(1).map(item=>{
                    const v_player_name =  String(item[0] || '')
                    const v_partner_name = String(item[1] || '')
                    const v_player_association = String(item[2] || '')
                    if(v_player_name === '' && v_partner_name === '' && v_player_association === ''){
                        return null;
                    }
                    return {
                        v_player_name: v_player_name,
                        v_partner_name: v_partner_name,
                        v_player_association: v_player_association
                    }
                }).filter(item => item !== null)
                // console.log(excelDataFormat)
                let json = {
                        SumCount: excelDataFormat.length-1,
                        DataTable: excelDataFormat
                    }
                let params = {
                    opcode: 100,
                    i_serial_mark:this.pubId,
                    jsondata:  JSON.stringify(json)
                }
                // console.log(params)

                this.$api.requestAPI(params).then(res=>{
                    if(res.IsSuccess){
                        this.$message.success("导入数据成功")
                        this.initData()
                        this.$refs.fileInput.value = '';
                    }else{
                        this.$message.error("导入数据失败")
                    }
                })                
            };
            reader.readAsArrayBuffer(file);
        },  
        handleFileUpload(file,fileList){
            // console.log(fileList)
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
        
                // 假设我们只处理第一个工作表
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                this.importData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                console.log(this.importData)
                // 这里可以添加将解析后的数据发送到服务器的逻辑
                // 例如：axios.post('/api/upload', this.importData).then(response => {...}).catch(error => {...});               
        
                // 重置文件列表，因为我们是手动处理的上传
                this.fileList = [];
            };
            reader.readAsArrayBuffer(file.raw);
        
            // 阻止默认的上传行为
            return false;
        },
        beforeUpload(file){
            // 在这里可以进行文件大小、类型等的校验
            const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                file.type === 'application/vnd.ms-excel';
            if (!isXLSX) {
                this.$message.error('上传文件只能是xlsx/xls格式!');
            }

            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 2MB!');
            }
            return isXLSX && isLt2M;
        },
        handleRemove(file, fileList){
            console.log(file, fileList);
        },
        handleExceed(files, fileList){
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
        },
        handleDownLoadXLS(){
            let exportData = [{'选手姓名':'','搭档姓名':'','协会（俱乐部）':''}]
            this.$help.ExportFormData(exportData,'选手信息表')
        },
        handleRemoveAll(){
            this.$confirm('确认删除全部选手吗？','警告').then(()=>{                
                if(this.tableData.length > 0){
                    this.confirmRemoveAll()
                }else{
                    this.$message.error('暂无选手可删除')
                }
            }).catch()
        },
        confirmRemoveAll(){
            let params = {
                opcode: this.$code.PubRemove,
                i_serial_mark: this.pubId,
                i_players_number: 0,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },        
        // 切换列显示/隐藏的方法
        toggleAssociationColumn() {
            this.showAssociationColumn = !this.showAssociationColumn;
        }
    }
}
</script>
<style lang='scss' scoped>
.flex-row-1{
    width: 100%;
}
.player-table {
    width: 33%;
}
.player-table >>> .el-table{
    font-size: 20px;    
}
.player-table >>> .el-table .cell{
    font-size: 20px;
    padding: 0 !important;
    color:#000
}
.player-table >>> .el-input{
    font-size: 20px;
}

.player-table >>> .el-input__inner{
    border: none !important;
    box-shadow: none !important;
    padding: 0;
    color: #000;
    text-align: center !important;
}
.player-table >>> .el-table__cell{
    font-size: 20px;
}   
.player-table >>> .el-table__row .el-table__cell{
    padding: 0;
    margin: 0;
}   
.inline-input >>> .el-input__inner{
    color: #f75e00
}
.upload-demo {
  display: inline-block;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.upload-demo .el-upload {
  border: none;
  background: none;
}
.upload-demo .el-upload__input {
  display: none;
}
.file-excel{
    position: relative;
    margin-left: 15px;
}
.input-file{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    filter: alpha(opacity=0);
    font-size: 0;   
}
.input-button{
    display: inline-block;
    padding: 10px 20px;
    background-color: #f75e00;
    border: 1px solid #f75e00;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/components/player.vue